@if(modelArray.length) {
@for(item of modelArray; track $index ){
@switch (model?.data && model?.type) {
@case ('page') {
<page-view [model]="pageModel" />
}
@case ('category') {
<category-view [model]="categoryModel" />
}
@case ('product') {
@switch (productModel.giftCard.isGiftcard) {
@case (true) {
<giftcards-product-view cy-ppContainer
                        [modelId]="model?.id" />
}
@default {
<product-view cy-ppContainer
              [model]="productModel" />
}
}
}
@default {
<error-404 />
}
}
}
} @else {
<error-404 />
}